import React from 'react';
import './sw-simple-link-pagination.scss';
import classnames from 'classnames';
import { Button, Divider } from 'antd';
import { tryParseInt } from '../../utils/try-parse';
function SwSimpleLinkPagination(props) {
  var _props$links, _props$links2;
  var paginationLinks = [];
  var prevLink = (_props$links = props.links) === null || _props$links === void 0 ? void 0 : _props$links.prev;
  var nextLink = (_props$links2 = props.links) === null || _props$links2 === void 0 ? void 0 : _props$links2.next;
  paginationLinks.push(/*#__PURE__*/React.createElement(Button, {
    key: "sw-table-pagination-prev",
    className: classnames('sw-table-pagination-prev', 'sw-table-pagination-link', {
      'sw-table-pagination-link-disabled': !prevLink
    }),
    size: "small",
    disabled: !prevLink,
    onClick: function onClick(ev) {
      if (prevLink) {
        var _props$onPrev;
        var prevUrl = new URL(prevLink);
        var prevPage = tryParseInt(prevUrl.searchParams.get('page'));
        (_props$onPrev = props.onPrev) === null || _props$onPrev === void 0 ? void 0 : _props$onPrev.call(props, ev, prevLink, {
          current: prevPage
        });
      }
    }
  }, /*#__PURE__*/React.createElement("span", null, "Previous")));
  paginationLinks.push(/*#__PURE__*/React.createElement(Divider, {
    key: "sw-table-pagination-div",
    className: "sw-table-pagination-div",
    type: "vertical"
  }));
  paginationLinks.push(/*#__PURE__*/React.createElement(Button, {
    key: "sw-table-pagination-next",
    className: classnames('sw-table-pagination-next', 'sw-table-pagination-link', {
      'sw-table-pagination-link-disabled': !nextLink
    }),
    size: "small",
    disabled: !nextLink,
    onClick: function onClick(ev) {
      if (nextLink) {
        var _props$onNext;
        var nextUrl = new URL(nextLink);
        var nextPage = tryParseInt(nextUrl.searchParams.get('page'));
        (_props$onNext = props.onNext) === null || _props$onNext === void 0 ? void 0 : _props$onNext.call(props, ev, nextLink, {
          current: nextPage
        });
      }
    }
  }, /*#__PURE__*/React.createElement("span", null, "Next")));
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('sw-table-pagination', 'sw-simple-link-pagination', {
      'sw-table-pagination-has-prev': !!prevLink,
      'sw-table-pagination-has-next': !!nextLink,
      'sw-table-pagination-single-page': !prevLink && !nextLink
    })
  }, paginationLinks);
}
export default SwSimpleLinkPagination;